export default {
  isShown: (state) => state.isShown,
  menuItemsList: (state) => state.menuItemsList,
};
